import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var NotificationTypeComponent = function (_a) {
    var type = _a.type, message = _a.message, handleIconClick = _a.handleIconClick, rest = __rest(_a, ["type", "message", "handleIconClick"]);
    return (React.createElement("div", __assign({ className: "pgc-notification ".concat(type) }, rest),
        React.createElement("i", { className: "icon-".concat(type, " pgc-notification-icon"), onClick: function () { return handleIconClick(); } }),
        React.createElement("span", { className: 'pgc-notification-text' }, message)));
};

export { NotificationTypeComponent };
